<template>
  <div>
    <div class="input-wrap">
      <input type="text" class="form-control" v-model="cDate" @keyup="$emit('updateDate',cDate);" placeholder="00:00" @change="validateHhMm(this);"/>
      <!-- <textarea rows="4" cols="63" v-model="cDate.notes"> </textarea> -->
      <a href="#message-modal" class="msg-modal" @click.prevent="isShow = true">
        <span class="ico-message-icon"></span>
      </a>
    </div>
    <!-- Modal -->
    <div class="my-modal" id="message-modal" :class="{'d-block':isShow, 'd-none':!isShow}">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
   
          <div class="modal-body p-20">
            <!-- <div class="d-flex mb-10">
              <h5 class="modal-title" id="exampleModalLongTitle">
                Project Name:
              </h5>
              <p>{{ projectName }}</p>
            </div> -->

            <h5 class="modal-title text-left">Add Message:</h5>
            <textarea rows="4" class="txtarea-responsive"  v-model="comment" @keyup="$emit('updateNotes',comment);"> </textarea>
            <!-- <div class="modal-body px-0 py-0 text-left">
              <div class="modal-body px-0">
                <div class="url-inputs">
                  <label>Paste URL Here :</label>
                  <input type="url" v-model="linkOne" />
                </div>
                <div class="url-inputs">
                  <label>Paste URL Here :</label>
                  <input type="url" v-model="linkTwo" />
                </div>
              </div>
            </div> -->
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="isShow = false"
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="isShow = false"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.my-modal {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}
.txtarea-responsive{
  width: 100%;
}
.modal-dialog.modal-dialog-centered {
    z-index: 2222;
}
</style>
<script>
import moment from "moment";
import { extendMoment } from "moment-range";
import Multiselect from "vue-multiselect";
export default {
  name: "DateWithNotes",
  components: {
    Multiselect,
  },
  props: {
    cDate: String,
    comment: String,
    projectName: String,
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    saveMessage() {
      $("#message-modal").modal("hide");
      // console.log(notes);
    },
    validateHhMm(inputField) {
        const time = '23:59' 
        moment(time, 'HH:mm', true).isValid()
  }
  },
};
</script>
